import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import ProductBlock$1 from '../components/ProductBlock.js';
import { useCommerceToolsProductData } from '../hooks/use-ct-product-data.js';

const CommerceToolsProductBlock = ({ product , formatProductUrl , onClick , onImpression , className , reimbursableLogos ,  })=>{
    const [activeSku, setActiveSku] = React.useState(product.masterVariant.sku || '');
    const { wasSeen , ref  } = useWasSeenByUser();
    const handleVariantChange = React.useCallback((sku)=>{
        sku && setActiveSku(sku);
    }, []);
    React.useEffect(()=>{
        if (wasSeen && onImpression) onImpression();
    }, [
        wasSeen
    ]);
    const { productType , variantInfo , variantUrl , variantImages , otherVariants , promotionLabel , isInsuranceReimbursable ,  } = useCommerceToolsProductData(product, activeSku, formatProductUrl);
    if (!variantInfo || !variantUrl) {
        console.error('CommerceToolsProductBlock: missing critical info required for rendering', {
            variantInfo,
            variantUrl
        });
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductBlock$1, swcHelpers.extends({
        ref: ref,
        className: className,
        url: variantUrl,
        images: variantImages,
        variants: otherVariants || [],
        promotionLabel: promotionLabel,
        productType: productType,
        activeSku: activeSku,
        reimbursableLogos: reimbursableLogos,
        onVariantChange: handleVariantChange,
        onClick: onClick,
        isInsuranceReimbursable: isInsuranceReimbursable
    }, variantInfo));
};
var ProductBlock = CommerceToolsProductBlock;

export { CommerceToolsProductBlock, ProductBlock as default };
//# sourceMappingURL=CommerceTools.js.map
